<template>
  <div class="dropdown-wrapper" @click.stop>
    <input
      type="text"
      class="form-control"
      v-model="search"
      :disabled="disabled"
      :placeholder="effectivePlaceholder"
      @focus="isOpen = true"
      @blur="handleBlur"
    />

    <ul v-if="isOpen && filteredOptions.length" class="dropdown-list">
      <li
        v-for="option in filteredOptions"
        :key="option._id"
        @mousedown.prevent="selectOption(option)"
      >
        {{ option.firstName }} {{ option.lastName || "" }}
      </li>
    </ul>

    <p v-if="isOpen && !filteredOptions.length" class="no-results">
      No match found
    </p>
  </div>
</template>

<script>
export default {
  name: "SearchableDropdown",
  props: {
    modelValue: String,
    options: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      default: "firstName",
    },
    effectivePlaceholder: {
      type: String,
      default: "Select an option",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      search: "",
      isOpen: false,
    };
  },
  computed: {
    filteredOptions() {
      return this.options.filter((option) => {
        const name = `${option.firstName} ${
          option.lastName || ""
        }`.toLowerCase();
        return name.includes(this.search.toLowerCase());
      });
    },

    effectivePlaceholder() {
      if (!this.disabled) return this.placeholder;

      const selected = this.options.find((o) => o._id === this.modelValue);
      return selected
        ? `${selected.firstName} ${selected.lastName || ""}`.trim()
        : this.placeholder;
    },
  },
  watch: {
    modelValue(newVal) {
      const match = this.options.find((o) => o._id === newVal);
      if (match) {
        this.search = `${match.firstName} ${match.lastName || ""}`;
      }
    },
  },
  methods: {
    selectOption(option) {
      this.search = `${option.firstName} ${option.lastName || ""}`;
      this.$emit("update:modelValue", option._id);
      this.isOpen = false;
    },
    handleBlur() {
      setTimeout(() => {
        this.isOpen = false;
      }, 200);
    },
  },
  mounted() {
    const match = this.options.find((o) => o._id === this.modelValue);
    if (match) {
      this.search = `${match.firstName} ${match.lastName || ""}`;
    }
  },
};
</script>

<style scoped>
.dropdown-wrapper {
  position: relative;
}
.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  max-height: 200px;
  overflow-y: auto;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  overflow: hidden;
  z-index: 10;
  padding: 0;
  margin: 0;
  list-style: none;
}
.dropdown-list li {
  padding: 10px;
  cursor: pointer;
}
.dropdown-list li:hover {
  background-color: #f2f2f2;
}
.no-results {
  padding: 10px;
  color: #999;
}
</style>
